﻿import m from 'mithril'
import icon from './icon'

var loading = {}

loading.view = vnode => {
	return m('.loading.w-100.text-center.mt-3.mb-3', [m(icon, { iconName: 'circle-o-notch icon-spin' })])
}
export default loading
